import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Experience } from './components/Experience';
import { Education } from './components/Education';
import { Certifications } from './components/Certifications';
import { Skills } from './components/Skills';
import { Contact, Footer } from './components/Contact';
import { sebData } from './data/sebastian';
import './App.css';

function App() {
  return (
    <div className="app">
      <Navbar />
      <Hero
        name={sebData.name}
        title={sebData.title}
        location={sebData.location}
        bio={sebData.bio}
        email={sebData.email}
        phone={sebData.phone}
      />
      <About bio={sebData.bio} />
      <Experience items={sebData.experience} />
      <Education items={sebData.education} />
      <Certifications items={sebData.certifications} />
      <Skills items={sebData.skills} />
      <Contact
        email={sebData.email}
        phone={sebData.phone}
        social={sebData.social}
      />
      <Footer />
    </div>
  );
}

export default App;
